(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-v2-blog-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  function applyOrder(track, doShuffle) {
    if (window.Shopify && window.Shopify.designMode) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.cb-v2-bl__card'));
    var pinned = cards.filter(function (c) { return c.getAttribute('data-pinned') === 'true'; });
    var free = cards.filter(function (c) { return c.getAttribute('data-pinned') !== 'true'; });
    if (doShuffle) shuffle(free);
    pinned.concat(free).forEach(function (c) { track.appendChild(c); });
  }

  function initSection(el) {
    var track = el.querySelector('.cb-v2-bl__track');
    var prevBtn = el.querySelector('.cb-v2-bl__arrow--prev');
    var nextBtn = el.querySelector('.cb-v2-bl__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    applyOrder(track, track.getAttribute('data-shuffle') === 'true');

    function scrollByCard(dir) {
      var cards = track.querySelectorAll('.cb-v2-bl__card');
      if (!cards.length) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * (cards[0].offsetWidth + gap), behavior: 'smooth' });
    }

    function updateArrows() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      prevBtn.style.opacity = atStart ? '0.3' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
      nextBtn.style.opacity = atEnd ? '0.3' : '1';
      nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
    }

    prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cb-v2-bl').forEach(initSection);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
